import { VIEW_ITEM_TILE } from "constants/view-defs";
import { SchemaRecord } from "records/schema";

interface IViewDefOptions {
    viewName?: string;
    ids: string[];
    entries: Record<string, { view_name: string; schema_id: string }>;
    schema: SchemaRecord;
}

export const getViewDef = ({ viewName = VIEW_ITEM_TILE, ids, entries, schema }: IViewDefOptions) => {
    const itemTileId = ids.find(
        (viewDefId: string) => entries[viewDefId].view_name === viewName && entries[viewDefId].schema_id === schema._id
    );
    return entries[itemTileId];
};
